import type { SessionCartIdentityData } from "~/app/store/bffApi";
import { queryClient } from "~/app/queryClient";
import { sessionQueryOptions } from "~/app/api/pageData";
import { userIsLoggedIn } from "~/domains/user/utils/roles";

export function activeCartResourceId(
  activeCart: SessionCartIdentityData | null | undefined,
  authenticated: boolean,
): string | undefined {
  if (!activeCart) {
    return undefined;
  }
  return authenticated ? activeCart.code : activeCart.guid;
}

/**
 * Resolves the authoritative Active Cart resource identity from fresh Session Data.
 * A strict duplicate-cart 409 propagates to the caller and no cart transport is attempted.
 */
export async function resolveActiveCartResourceId(): Promise<string | undefined> {
  const session = await queryClient.fetchQuery(sessionQueryOptions());
  return activeCartResourceId(session.activeCart, userIsLoggedIn());
}
